module.exports = __webpack_public_path__ + "img/colismart.6afb95a8.png";